import SUPABASE_CONFIG from "@/hooks/supabase/.env.supabase";
import { createClient } from '@supabase/supabase-js'
export const supabase = createClient(SUPABASE_CONFIG.supabase_url, SUPABASE_CONFIG.supabase_key)
export const storageBaseUrl = SUPABASE_CONFIG.supabase_storage